import * as React from 'react';
import LocalDiv from '../../../localization/LocalDiv';
import { DevPlanFieldListItem } from './models';
import { css } from '@emotion/core';
import { FLEX_ROW } from '../../../layout/flexBox';
import LocalHTMLContainer from '../../../localization/LocalHTMLContainer';


const styles = {
  root:     [
    FLEX_ROW,
    css`
      align-items: center;
      font-size: 13px;
    `,
  ],
  itemTxt: css`
    flex-basis: 85%;
  `,
  checkbox: css`
    width: 22px;
    height: 22px;
  `,
};


type Props = {
  listItem: DevPlanFieldListItem;
  isSelected: boolean;
  toggleSelected: () => void;
  className?: string;
}

/**
 * DevActionListItem: a component that renders one of the choices used to answer dev action list items in the current
 * project
 */
const DevActionListItem: React.FC<Props> = ({ listItem, isSelected, toggleSelected, className }) => (
  <LocalDiv css={styles.root} className={className}>
    <LocalHTMLContainer innerHtml={listItem.text} css={styles.itemTxt} />
    <input type='checkbox' checked={isSelected} onChange={toggleSelected} css={styles.checkbox} />
  </LocalDiv>
);

export default DevActionListItem;
